<template>
  <section :class="`kpb-section kpb-section--theme-${theme} kpb-section--width-${width}`">
    <ScrollAnchor :data="scrollId" />
    <div class="kpb-section__container">
      <h2 v-if="title" class="kpb-section__title">{{ title }}</h2>
      <slot />
    </div>
  </section>
</template>

<script>
import ScrollAnchor from './ScrollAnchor.vue'

/** General section component for sectioning the page. */
export default {
  props: {
    theme: {
      type: String,
      default: 'default',
      validator(val) {
        return ['default', 'custom', 'primary', 'secondary', 'black', 'white', 'none'].includes(val)
      },
    },
    title: String,
    width: {
      type: String,
      default: 'medium',
      validator: val => ['full', 'large', 'medium', 'small'].includes(val),
    },
    id: String,
  },
  computed: {
    scrollId() {
      const id = this.id || Math.random(Math.random()).toString(32).slice(2)
      return `section-${id}`
    },
  },
  components: { ScrollAnchor },
}
</script>

<style lang="scss">
.kpb-section {
  padding-block: var(--section-padding-block, clamp(2rem, 6vw, 6rem));

  &__container {
    max-width: var(--section-width);
    width: 100%;
    margin-inline: auto;
    padding-inline: var(--section-padding-inline, 1rem);
  }

  /* Themes */

  &--theme {
    &-none,
    &-default {
      background-color: transparent;
    }

    &-primary,
    &-secondary,
    &-custom,
    &-black {
      h1,
      h2 {
        color: inherit;
      }
    }

    &-primary {
      background-color: var(--primary);
      color: var(--primary-contrast);
      border-color: var(--secondary);

      .kpb-text {
        svg path {
          fill: var(--primary-contrast) !important;
        }
      }
    }
    &-secondary {
      background-color: var(--secondary);
      color: var(--secondary-contrast);
      border-color: var(--primary);

      .kpb-text {
        svg path {
          fill: var(--secondary-contrast) !important;
        }
      }
    }
    &-custom {
      background-color: var(--custom-background-color, white);
      color: var(--custom-body-color, black);
      border-color: var(--primary);

      .kpb-text {
        svg path {
          fill: var(--custom-body-color, var(--primary)) !important;
        }
      }
    }

    &-white {
      background-color: white;
      border-color: black;
    }
    &-black {
      background-color: black;
      color: white;
      border-color: white;

      .kpb-text {
        svg path {
          fill: white !important;
        }
      }
    }
  }

  /* Widths */
  &--width {
    &-small {
      --section-width: 1000px;
    }
    &-medium {
      --section-width: 1400px;
    }
    &-large {
      --section-width: 1700px;
    }
    &-full {
      --section-width: 100%;
      --section-padding-inline: 0rem;
    }
  }
}
</style>
